import { Injectable } from '@angular/core';
import { apiEndPoints } from 'src/app/common/constants/api-endpointsconstant';
import { ApiService } from 'src/app/common/services/api.service';
import { ReportService } from 'src/app/reports/services/report.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportResidentialPrimeService {
  constructor(
    private apiServive: ApiService,
    private reportService: ReportService
  ) { }

  /**
   *
   * @returns
   * OverView Data
  */
  getOverview() {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let url: string = `${environment.miUrl}${apiEndPoints.officeInventoryOverviewReportV2}${changeParams}`;
    return this.apiServive.get(url);
  }
}
